import { FunctionComponent, useMemo } from "react";
import { GameInfoProps } from "../../type";
import { Payout, Rule, Symbols } from "./type";
import HunkCaiShenUtils from "./utils";
import "./hunk-cai-shen.scss";
import Utils from "../../utils";

export const HunkCaiShenRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  return (
    <>
      <h5 className="card-title">Description</h5>
      <div className="ps-3">
        <p className="card-text">
          Hunk Cai Shen is a 5-reel, 3-row video slot featuring Multiplier Wild
          Symbols (x3,x4,x5) and free spin only has high payout symbol.
        </p>
      </div>
      <br />

      <h5 className="card-title">How to play</h5>
      <div className="ps-3">
        <p className="card-text">
          The game is played with 5 bet lines (fixed).
        </p>
        <p className="card-text">
          Winning combinations and payouts are made according to the "Paytable".
        </p>
        <p className="card-text">
          A bet line win in cash is equal to the value shown in the "Paytable"
          multiplied by the bet size.
        </p>
        <p className="card-text">
          Bet lines win if the winning symbols are in succession from the
          leftmost reel to right.
        </p>
        <p className="card-text">
          Simultaneous wins on different bet lines are added.
        </p>
        <p className="card-text">All wins are in cash. </p>
      </div>
      <br />

      <h5 className="card-title">Bonus Features</h5>
      <br />
      <div className="ps-3">
        <h6 className="card-title">
          Fortune Wild(x3,x4,x5)
          {[Symbols.Wild3, Symbols.Wild4, Symbols.Wild5].map((s) => (
            <div className="symbol">
              {HunkCaiShenUtils.convertSymbol(s, s + "-symbol")}
            </div>
          ))}
        </h6>
        <p className="card-text">
          Fortune Wild replaces all symbols except free game scatter. Fortune
          Wild only appear on reels 2 , 3 , 4. Each Fortune Wild will include a
          random multiplier of x3,x4 or x5.
        </p>

        <br />
        <h6 className="card-title">
          Scatter{" "}
          <div className="symbol">
            {HunkCaiShenUtils.convertSymbol(Symbols.Scatter, "scatter-symbol")}
          </div>
        </h6>
        <p className="card-text">
          Scatter symbols may appear randonly throughout the screen.
          <ul>
            <li>
              1 scatter appears on any reel, players will get 1x of total bet
            </li>
            <li> 2 scatter symbols = 3x total bet</li>
            <li> 3 scatter symbols = 12 Free Spins</li>
          </ul>
        </p>
      </div>
      <br />

      <h5 className="card-title">Payout Table</h5>
      <br />
      <div className="ps-3">
        <h6 className="card-title">Symbol Payout Values</h6>
        <br />
        <div className="d-flex justify-content-evenly mb-2">
          {[Symbols.Wild3, Symbols.Wild4, Symbols.Wild5, Symbols.Scatter].map(
            HunkCaiShenUtils.explainationSymbolPayout
          )}
        </div>
        <div className="d-flex justify-content-evenly mb-2">
          {[
            Symbols.Symbol1,
            Symbols.Symbol2,
            Symbols.Symbol3,
            Symbols.Symbol4,
            Symbols.Symbol5,
            Symbols.Symbol6,
          ].map(HunkCaiShenUtils.explainationSymbolPayout)}
        </div>
        <div className="d-flex justify-content-evenly mb-2">
          {[
            Symbols.LowSymbol1,
            Symbols.LowSymbol2,
            Symbols.LowSymbol3,
            Symbols.LowSymbol4,
          ].map(HunkCaiShenUtils.explainationSymbolPayout)}
        </div>
        <br />
        <p className="card-text">Wild symbol substitures for all symbols.</p>
        <br />
        <h6 className="card-title">Winning Bet Lines</h6>
        <br />
        <div className="d-flex justify-content-evenly mb-3 text-center">
          {Array.from({ length: 3 }, (_, i) => i + 1).map((line) => (
            <div key={`line-${line}`}>
              {Utils.drawLine(3, HunkCaiShenUtils.takePayline(line))}
              <span>Line {line}</span>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-evenly mb-3 text-center">
          {Array.from({ length: 2 }, (_, i) => i + 4).map((line) => (
            <div key={`line-${line}`}>
              {Utils.drawLine(3, HunkCaiShenUtils.takePayline(line))}
              <span>Line {line}</span>
            </div>
          ))}
        </div>
        <br />
        <br />
        <p className="card-text">Only the highest win per bet line is paid.</p>
        <p className="card-text">
          Bet lines win if the winning symbols are in succession from the
          leftmost reel to the right.
        </p>
        <p className="card-text">All wins shown in cash.</p>
      </div>
      <br />

      <h5 className="card-title">Auto Bet</h5>
      <div className="ps-3">
        <p className="card-text">
          Choose between a preset number of rounds and bet options
        </p>
        <p className="card-text">
          Auto mode will be cancelled when the player leaves the game window/tab
          or app
        </p>
      </div>
      <br />
    </>
  );
};
